import Button from 'components/shared/app/Button';
import { get } from 'lodash';
import React, { useEffect, useState } from 'react';
import arrowIcon from 'static/icons/icon_arrow_blue_round.svg';

const SignupSelectAccount = (props) => {
    const [selectedAccountId, setSelectedAccountId] = useState(props.fbAccount || get(props, 'accounts[0].id', null));
    const [accountPixels, setAccountPixels] = useState(undefined);
    const [selectedPixel, setSelectedPixel] = useState(useState(props.fbPixel, null));

    useEffect(() => {
        if (selectedAccountId) {
            let a = props.accounts.find(_a => `act_${_a.account_id}` == selectedAccountId);
            // load pixels for the account...
            if (a && a.adspixels && a.adspixels.data.length) {
                setAccountPixels(a.adspixels.data);
                setSelectedPixel(a.adspixels.data[0]);
            }
        }
    }, [selectedAccountId]);

    const accountChanged = (accountId) => {
        setSelectedAccountId(accountId);
    }

    const submitSave = () => {
        props.setFbAccount(selectedAccountId);
        props.setFbPixel(selectedPixel ? selectedPixel.id : undefined);
        props.setSignupState(2);
    }

    const renderContinueButton = () => {
        if (selectedAccountId) {
            if (selectedPixel || !accountPixels) {
                return <Button round simple bold filled center color="white" icon={<img src={arrowIcon} />} iconPosition="right" textPosition="center"
                    onClick={() => submitSave()}>Continue</Button>
            }
        }
        return <Button round simple bold filled center color="white" icon={<img src={arrowIcon} />} iconPosition="right" textPosition="center" enabled={false}>Continue</Button>
    }

    return (
        <div className="step signup-select-account flex-col">

            {props.accounts && props.accounts.length ? (
                <>

                    <div className="section ad-account">
                        <h2 className="font-plain-large center">Select your Ad Account:</h2>
                        <select className="input simple margin lg ns" onChange={(e) => accountChanged(e.target.value)} value={selectedAccountId}>
                            <option default disabled>Select...</option>
                            {
                                props.accounts.map(a => {
                                    return (
                                        <option key={a.account_id} value={a.id}>{a.name} ({a.account_id})</option>
                                    )
                                })
                            }
                        </select>
                    </div>

                    {selectedAccountId && accountPixels &&
                        <div className="section select-pixel">
                            <h2 className="font-plain-large center">Select which Facebook Pixel to use for this account:</h2>
                            <select className="input simple margin lg ns" onChange={(e) => setSelectedPixel(e.target.value)} value={selectedPixel ? selectedPixel.id : undefined}>
                                <option default disabled>Select...</option>
                                {
                                    accountPixels.map(p => {
                                        return (
                                            <option key={p.id} value={p.id}>{p.name} ({p.id})</option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                    }
                </>
            ) : 'No results'}

            {renderContinueButton()}

            <Button round simple bold center color="white" onClick={() => props.setSignupState(0)}>Back</Button>

        </div>
    )
}

export default SignupSelectAccount